"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderToJSON = exports.SalesOrderFromJSONTyped = exports.SalesOrderFromJSON = exports.instanceOfSalesOrder = void 0;
var runtime_1 = require("../runtime");
var SalesforceUser_1 = require("./SalesforceUser");
/**
 * Check if a given object implements the SalesOrder interface.
 */
function instanceOfSalesOrder(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSalesOrder = instanceOfSalesOrder;
function SalesOrderFromJSON(json) {
    return SalesOrderFromJSONTyped(json, false);
}
exports.SalesOrderFromJSON = SalesOrderFromJSON;
function SalesOrderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'creator': !(0, runtime_1.exists)(json, 'creator') ? undefined : (0, SalesforceUser_1.SalesforceUserFromJSON)(json['creator']),
    };
}
exports.SalesOrderFromJSONTyped = SalesOrderFromJSONTyped;
function SalesOrderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'title': value.title,
        'creator': (0, SalesforceUser_1.SalesforceUserToJSON)(value.creator),
    };
}
exports.SalesOrderToJSON = SalesOrderToJSON;
